import React, { useCallback, useEffect } from 'react';
import { TreatmentTemplate } from 'types/treatmentTemplate';
import { getTreatmentTemplateById } from 'api/videoSetting';

const useGetTemplateDetail = (id?: number, autoFetch = false): [TreatmentTemplate | undefined, boolean, (id: number) => void] => {
    const [loading, setLoading] = React.useState(false);
    const [item, setItem] = React.useState<TreatmentTemplate>();

    const fetchData = useCallback(async (id: number) => {
        if (loading || !id) return;
        try {
            setLoading(true);
            const result = await getTreatmentTemplateById(id);
            if (!result.error) {
                setItem(result?.data?.data);
            }
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    }, [loading]);

    useEffect(() => {
        if (autoFetch && id) {
            fetchData(id);
        }
    }, [id, autoFetch]);

    return [item, loading, fetchData];
};

export default useGetTemplateDetail;
